/** Reads ?booking_paid=1&service=<key> from a post-payment return — Stripe's
 *  success_url and Calendly's "Redirect to an external site" both land here. */
export function parseBookingReturn(search: string): string | null {
  const params = new URLSearchParams(search);
  if (params.get("booking_paid") !== "1") return null;
  const key = params.get("service");
  return key && key.trim() ? key : null;
}

/** Extra params Calendly appends when "Pass event details to your redirected
 *  page" is on. Listed so the address bar is clean once the confirmation is
 *  shown — `answer_*` (custom questions) and `utm_*` are matched by prefix. */
const CALENDLY_RETURN_PARAMS = [
  "assigned_to",
  "event_type_uuid",
  "event_type_name",
  "event_start_time",
  "event_end_time",
  "invitee_uuid",
  "invitee_full_name",
  "invitee_first_name",
  "invitee_last_name",
  "invitee_email",
  "text_reminder_number",
];

/** `href` without the return params — what replaceState puts in the address
 *  bar so a reload (or a shared link) doesn't re-open the confirmation. */
export function stripBookingReturnParams(href: string): string {
  const url = new URL(href);
  const drop = [
    "booking_paid",
    "service",
    ...CALENDLY_RETURN_PARAMS,
    ...Array.from(url.searchParams.keys()).filter(
      (k) => k.startsWith("answer_") || k.startsWith("utm_"),
    ),
  ];
  for (const key of drop) url.searchParams.delete(key);
  return url.pathname + url.search + url.hash;
}
